// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d87e8325","692":"5ac698d0","884":"1bf60218"}[chunkId] + ".chunk.js";
};